'use client'

// src/utils/date.ts
var calculateDateToBuy = ({
  startDate,
  counter = { years: 0, months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 }
}) => {
  const { months = 0, days = 0, hours = 0, minutes = 0, seconds = 0 } = counter;
  const timeNow = /* @__PURE__ */ new Date();
  let timeToBuy = timeNow.setMonth(timeNow.getMonth() + months);
  timeToBuy = timeNow.setDate(timeNow.getDate() + days);
  timeToBuy = timeNow.setHours(timeNow.getHours() + hours);
  timeToBuy = timeNow.setMinutes(timeNow.getMinutes() + minutes);
  timeToBuy = timeNow.setSeconds(timeNow.getSeconds() + seconds);
  return timeToBuy > 0 ? new Date(timeToBuy) : new Date(startDate);
};

export {
  calculateDateToBuy
};
//# sourceMappingURL=chunk-BEOLAJXM.mjs.map